<template>
	<div>

		<div class="lb_bgi">
			<div class="title">
				智慧水肥
			</div>
			<div 	style="display: flex;align-items: center;justify-content: center;flex-direction: column;position: relative;top:80px">
				<img :src="img" alt="" style="width: 168px;height: 81px;" />
				<div class="con1">智慧水肥</div>
				<div class="con2">功能开发中...</div>
			</div>
		</div>





	</div>
</template>

<script>
	import {
		Message
	} from 'element-ui';
	export default {

		data() {
			return {
				img: require('../assets/empty.png'),

				msg: {}
			}
		},
		mounted() {

		},
		methods: {}
	}
</script>

<style scoped lang="less">
	.lb_bgi {
		width:28vw;
		height: 28vh;
		background-image: url(/src/assets/lb.png);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		position: relative;

	}

	.title {

		font-family: Source Han Sans CN;
		font-weight: bolder;
		font-size: 18px;
		color: #FFFFFF;
		font-style: italic;
		background: linear-gradient(0deg, #B5FFDA 0%, #FFFFFF 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		position: absolute;
		left: 70px;
		top: 8px
	}

	.con1 {
		font-family: Source Han Sans CN;
		font-weight: bold;
		font-size:18px;
		color: #FFFFFF;
		font-style: italic;
		background: linear-gradient(0deg, #B5FFDA 0%, #FFFFFF 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		margin-top: 10px;
	}

	.con2 {
		width: 70px;
		height: 13px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 12px;
		color: #FFFFFF;
		line-height: 42px;
		margin-top: 10px;
		border: 1px solid #B5FFDA;
		border-radius: 40px;
		padding: 5px 14px 5px 14px;
	}
</style>